<script setup>
import { useI18n } from 'vue-i18n';
import FollowUp from 'dashboard/components-next/FollowUp/FollowUp.vue';

defineProps({
  contactId: { type: Number, required: true },
  hasConversation: { type: Boolean, default: false },
  email: { type: String, default: '' },
  nextFollowUpAt: { type: String, default: '' },
  followUpNote: { type: String, default: '' },
  meetingRequired: { type: Boolean, default: false },
  meetingProvider: { type: String, default: '' },
  meetingUrl: { type: String, default: '' },
  meetingReference: { type: String, default: '' },
  followUpType: { type: String, default: '' },
  meetingLocation: { type: String, default: '' },
  followUpTeamId: { type: [Number, String], default: '' },
  assignee: { type: Object, default: null },
  ccEmails: { type: Array, default: () => [] },
});

const { t } = useI18n();
</script>

<template>
  <div
    class="flex flex-col gap-3 p-3 border rounded-lg border-n-weak bg-n-solid-2"
  >
    <h3 class="text-sm font-medium text-n-slate-12">
      {{ t('FOLLOW_UP.TITLE') }}
    </h3>

    <FollowUp
      mode="summary"
      :contact-id="contactId"
      :has-conversation="hasConversation"
      :email="email"
      :next-follow-up-at="nextFollowUpAt"
      :follow-up-note="followUpNote"
      :meeting-required="meetingRequired"
      :meeting-provider="meetingProvider"
      :meeting-url="meetingUrl"
      :meeting-reference="meetingReference"
      :follow-up-type="followUpType"
      :meeting-location="meetingLocation"
      :follow-up-team-id="followUpTeamId"
      :assignee="assignee"
      :cc-emails="ccEmails"
    />
  </div>
</template>
